module.exports = __webpack_public_path__ + "static/img/logo_033.5f529bd5.png";